export default "./dist/stdassets/images/icons/maptip.png";